import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getConsentStatus } from './helpers';
import { CONSENT_ASSIGNMENT_TYPE } from '../../../../../constants/consentStatus';
import Icon from '../../../../Icon';
import styles from './index.styl';

const ViewConsent = ({
  name,
  status,
  version,
  fileUrl,
  expiresAt,
  programName,
  formatMessage,
  statusChangedAt,
  consentTypeTitle,
  consentAssignmentType,
}) => {
  const consentVersionTitle = formatMessage({
    id: 'appointment.consent.consentVersion',
  });

  const paperConsentTitle = formatMessage({
    id: 'appointment.consent.paper',
  });

  const isPaperConsent =
    consentAssignmentType === CONSENT_ASSIGNMENT_TYPE.PAPER_CONSENT;

  return (
    <div className={styles.consentItem} onClick={() => window.open(fileUrl)}>
      <Icon name="icon-document-black" size={32} className={styles.icon} />
      <div className={styles.consentInfoWrapper}>
        <div className={styles.consentTitle}>{name}</div>
        <div className={styles.consentSubtitleRow}>
          <div className={styles.consentSubTitle}>
            {`${consentTypeTitle}, ${
              isPaperConsent
                ? paperConsentTitle
                : `${consentVersionTitle} ${version}`
            }`}
          </div>

          {programName && (
            <div className={styles.consentSubTitle}>
              {formatMessage({ id: 'common.program' })}: {programName}
            </div>
          )}

          <div className={styles.consentSubTitle}>
            {getConsentStatus({
              status,
              expiresAt,
              formatMessage,
              statusChangedAt,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

ViewConsent.propTypes = {
  name: PropTypes.string,
  status: PropTypes.string,
  version: PropTypes.number,
  fileUrl: PropTypes.string,
  expiresAt: PropTypes.string,
  formatMessage: PropTypes.func,
  programName: PropTypes.string,
  statusChangedAt: PropTypes.string,
  consentTypeTitle: PropTypes.string,
  consentAssignmentType: PropTypes.string,
};

export default memo(ViewConsent);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/RenderViewConsents/ViewConsent/index.jsx